import Title from './Title';
import Btn from './Btn';
import PackagePlan from './PackagePlan';

export default function Packaging() {

    return <>
        <div class="packages py-3 py-sm-4 py-lg-5 my-lg-5 ">
            <div class="container">
                <div className='packagingTitle mb-5 pb-1'>
                    <div className='row  justify-content-between align-items-center'>
                        <div className='col-md-6'>
                            <Title mainClass=" d-block"
                                titleclass="lg text-dark text-center text-md-start mb-2"
                                desclass="mb-0 text-md-start text-center"
                                title={<>Best Place to Book your Move!</>}
                                des="When it comes to residential local moving, there’s no such thing as a “one size fits all” solution." />
                        </div>
                        <div class="col-md-6 d-flex flex-wrap mt-3 mt-md-0 justify-content-center justify-content-md-end">
                            <Btn class="position-relative mt-4 mt-md-0 "
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            > Book Moving & Packing Truck</Btn>
                        </div>
                    </div>
                    </div>
                    <PackagePlan />
                </div>
        </div>
    </>
}